import fr from "../translate.json";
import en from "../translate.en.json";

export const DEFAULT_LANGUAGE = "fr";
export const LANGUAGE_STORAGE_KEY = "happer_language";
export const SUPPORTED_LANGUAGES = ["fr", "en"];

const dictionaries = { fr, en };

export const getLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === "en") return "en";
  } catch (err) {
    // Ignore storage errors and keep the French default.
  }
  return DEFAULT_LANGUAGE;
};

export const setStoredLanguage = (lang) => {
  const next = lang === "en" ? "en" : DEFAULT_LANGUAGE;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, next);
  } catch (err) {
    // Ignore storage errors.
  }
  return next;
};

export const preserveLanguageAndClearStorage = () => {
  const language = getLanguage();
  localStorage.clear();
  setStoredLanguage(language);
};

const interpolate = (text, vars) => {
  if (!vars || typeof vars !== "object") return text;

  let next = text;
  if (vars.count != null) {
    const count = String(vars.count);
    next = next.replace(/XX/g, count).replace(/X/g, count).replaceAll("{count}", count);
  }

  Object.entries(vars).forEach(([name, value]) => {
    if (name === "count") return;
    next = next.replaceAll(`{${name}}`, String(value));
  });

  return next;
};

const t = (key, vars) => {
  const lang = getLanguage();
  const dict = dictionaries[lang] || dictionaries.fr;
  const text = dict[key] ?? dictionaries.fr[key] ?? key;
  return interpolate(text, vars);
};

export default t;
